import * as React from 'react';
import * as moment from 'moment';

import { CalendarActions, ICalendarState } from '@adage/ace-calendar';
import { IArenaEvent } from '../classes/event';
import { connect } from 'react-redux';

import DropdownView from "../../views/controlled-dropdown";
import { IOption } from '../../classes/index';


interface ExternalProps {
    numberOfMonths: number;
    isMobile: boolean;
    invalidMonths: Array<moment.Moment>;
}

interface StateToProps {
    currMonth: string;
    startMonth: moment.Moment;
}

interface MonthSelectionState {
    monthDropdown: Array<IOption>;
    firstMonth: moment.Moment;
    lastMonth: moment.Moment;
}

type MonthSelectionProps = ExternalProps & StateToProps;

const _momentFormat = "MMM YYYY";

export class MonthSelection extends React.Component<MonthSelectionProps, MonthSelectionState> {


    constructor(props: MonthSelectionProps) {
        super(props);

        const curr = moment().clone();
        let dropdownOptions: Array<IOption> = [];

        for (let i = 0; i < props.numberOfMonths; ++i) {
            const value = curr.format(_momentFormat);

            if (props.invalidMonths.some(month => curr.startOf("month").isSame(month))) {
                dropdownOptions.push({ text: value, value: "disabled" });
            } else {
                dropdownOptions.push({ text: value, value: value });

            }


            curr.add(1, "month");
        }

        this.state = {
            monthDropdown: dropdownOptions,
            firstMonth: moment().clone().startOf("month"),
            lastMonth: moment().clone().add(props.numberOfMonths - 1, "months").startOf("month")
        };
    }

    private scrollToMonthOnLoad(momentObj: moment.Moment) {
        const interval = setInterval(() => {
            window.requestAnimationFrame(() => {

                const events = document.querySelectorAll('div[data-month]');
                console.log;
                for (let i = 0; i < events.length; ++i) {
                    if (moment(events[i].getAttribute("data-month")).month() === momentObj.month()) {
                        window.scrollTo({ top: (events[i] as any).offsetTop - 50 });
                        clearInterval(interval);
                        break;
                    }
                }
            });
        });
    }

    dropdownChange(evt: React.ChangeEvent<HTMLSelectElement>) {
        const momentObj = moment(evt.currentTarget.value, _momentFormat).endOf("month");

        if (this.props.isMobile) {
            CalendarActions.setDates(this.props.startMonth, momentObj);

            this.scrollToMonthOnLoad(momentObj);
        } else {
            CalendarActions.setMonth(momentObj);
        }

        CalendarActions.goToMonth(momentObj);
    }
    private boundDropdownChange = this.dropdownChange.bind(this);

    goToNextMonth(evt: React.MouseEvent<HTMLButtonElement>) {
        CalendarActions.nextMonth();

        this.scrollToMonthOnLoad(moment(this.props.currMonth, _momentFormat).add(1, "month"));
    }

    goToPrevMonth(evt: React.MouseEvent<HTMLButtonElement>) {
        CalendarActions.previousMonth();

        this.scrollToMonthOnLoad(moment(this.props.currMonth, _momentFormat).subtract(1, "month"));
    }

    render() {
        return (
            <div className="cal-filters-month-dropdown" >
                <button className="prev-month" disabled={this.state.firstMonth.isSameOrAfter(moment(this.props.currMonth, _momentFormat))} type="button" onClick={this.goToPrevMonth.bind(this)}></button>
                <DropdownView hideLabel={true} selectedValue={this.props.currMonth} options={this.state.monthDropdown} label="Month dropdown" htmlId="month-dropdown-js" onChange={this.boundDropdownChange} />
                <button className="next-month" disabled={this.state.lastMonth.isBefore(moment(this.props.currMonth, _momentFormat).endOf("month"))} type="button" onClick={this.goToNextMonth.bind(this)}></button>
            </div>
        );
    }
}

function mapStateToProps(state: ICalendarState<IArenaEvent>, ownProps: ExternalProps): StateToProps {
    return {
        currMonth: state.currentDate.format(_momentFormat),
        startMonth: state.startDate.clone()
    }
}

export default connect<StateToProps, null>(mapStateToProps, null)(MonthSelection);


// WEBPACK FOOTER //
// ./app/calendar/components/month-selection.tsx